module.exports = __webpack_public_path__ + "static/img/maadi_graphics-01.cf684d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maadi_graphics-01.png
// module id = ByKR
// module chunks = 1